import type { BlogStrings } from "../../types";

export const blog: BlogStrings = {
  index: {
    title: "博客",
    subtitle: "版本发布、设计手记，以及打造 CATE 一路上的故事。",
    empty: "还没有文章，过段时间再来看看。",
    latest: "最新",
    releases: "版本发布",
    releasesAll: "全部 →",
    pastArticles: "往期文章",
    pastHint: "拖动可重新排列 · 点击可打开",
  },
  post: {
    back: "← 博客",
    by: "作者",
    morePosts: "← 更多文章",
    keepReading: "继续阅读",
    notFoundTitle: "没找到这篇文章",
    notFoundBody: "这篇文章不存在，或者已经被挪走了。",
    notFoundBack: "← 返回博客",
  },
  release: {
    notFoundTitle: "没找到这个版本",
    notFoundBody: "没有与 v{version} 对应的版本。",
    notFoundBack: "← 返回博客",
    whatsIn: "这个版本带来了什么",
    download: "下载 v{version}",
    readStory: "阅读完整故事 →",
    levelMajor: "重大版本",
    levelMinor: "常规版本",
    levelPatch: "补丁",
  },
};
